export enum MenuManagerActionType {
    START_REQUEST = 'START_REQUEST',
    END_REQUEST = 'END_REQUEST',
    GET_MENU_SUMMARY_LIST = 'GET_MENU_SUMMARY_LIST'
}
